import { QUESTION_CATEGORY_VISIBILITY_SUBSCRIBED, QUESTION_CATEGORY_VISIBILITY_ALWAYS } from '../../constants/quests';

export function isQuestionCategoryVisible(category) {
    return !!(
        category &&
        // always visible
        (category.visibility == QUESTION_CATEGORY_VISIBILITY_ALWAYS ||
            // OR
            // self subscribable
            (category.visibility == QUESTION_CATEGORY_VISIBILITY_SUBSCRIBED && category.subscribed) ||
            // OR
            // subscribed (can be subscribed server side)
            category.subscribed)
    );
}
